const handleCounter = async () => {
  const selectors = {
    counter: '.js-counter',
  };

  const counters = document.querySelectorAll(selectors.counter);

  if (counters.length === 0) return;

  const { CountUp } = await import('countup.js');

  const addCounterIntersectionObserver = (counter) => {
    const { counterValue } = counter.dataset;
    const countUpEl = new CountUp(counter, counterValue, {
      startVal: 0,
      separator: ' ',
      duration: 3,
    });

    const counterObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          countUpEl.start();
          counterObserver.unobserve(counter);
        }
      });
    });

    counterObserver.observe(counter);
  };

  counters.forEach(addCounterIntersectionObserver);
};

export default handleCounter;
